@if (userAccount && isMobile) {
  <div class="gcontainer bwhite mobile-dashboard">
    <div class="row sticky-header">
      <div class="col-md-3">
        <div class="header-row">
          <h1 class="mat-h1-mobile">Dashboard</h1>
          <div class="header-right">
            <div class="header-item">
              <h1 class="mat-h1-mobile-right">{{ defaultTurnaroundTime }}</h1>
              <span class="sub-text">Default</span>
            </div>
            <div class="header-item">
              <h1 class="mat-h1-mobile-right">{{ rushTurnaroundTime }}</h1>
              <span class="sub-text">Rush</span>
            </div>
          </div>
        </div>
        <form (submit)="pageNavigate('keyWordSearch')" class="search-section">
          <mat-form-field appearance="outline">
            <input matInput placeholder="Search" class="search-text" appearance="legacy" floatLabel="never" maxlength="150" (input)="onSearchChange()"
              (keypress)="onKeyPress($event)" (keydown)="onKeyDown($event)" [(ngModel)]="searchKeyWord" [ngModelOptions]="{ standalone: true }" />
              @if (searchKeyWord.length === 0) {
                <mat-icon class="cursor search" matSuffix>search</mat-icon>
              }
              @if (searchKeyWord.length > 0) {
                <mat-icon class="cursor search" matSuffix (click)="onClearSearchButtonClick()">
                  close
                </mat-icon>
              }
            </mat-form-field>
            <div class="filter-row">
              <mat-checkbox color="primary" [checked]="selectedMobileMaterialTypes.includes('precast')"
                (change)="onMobileSoilTypeCheckboxChange('precast', $event.checked)">
                Pre Cast
              </mat-checkbox>
              <mat-checkbox color="primary" [checked]="selectedMobileMaterialTypes.includes('native')"
                (change)="onMobileSoilTypeCheckboxChange('native', $event.checked)">
                Native
              </mat-checkbox>
            </div>
          </form>
        </div>
      </div>
      <div class="row scroll-content" (scroll)="onScroll($event)">
        <div class="mobile-card-container">
          @for (project of projectRecords; track project; let i = $index) {
            <mat-card
              class="mobile-card"
              [class.active]="i === selectedCardIndex"
              (click)="onCardClick(i)">
              <div class="card-header" [ngStyle]="{'background-image': getBackgroundImage(project.soilType)}">
                <div class="title-wrap">
                  <span class="soil-chip">Company Name : {{ project.customer }}</span>
                  <h3 class="project-name">{{ project.projectName }}</h3>
                  <span class="soil-chip">{{ project.soilType }} : {{ project.status }}</span>
                  <span class="soil-chip">{{ project.sampleCountSummary }}</span>
                </div>
                @if (project.rushed === true || project.geothermField === true) {
                  <div class="card-badges">
                    @if (project.rushed === true) {
                      <img src="/assets/icons/Rush.svg" alt="rush-icon" class="badge-icon" />
                    }
                    @if (project.geothermField === true) {
                      <img src="/assets/icons/Success.svg" alt="geotherm-icon" class="badge-icon" />
                    }
                  </div>
                }
              </div>
              <mat-divider></mat-divider>
              <mat-card-content class="card-content">
                <div class="info-row">
                  <span class="label">Received Date</span>
                  <span class="value">{{ project.sampleReceivedDate | date: 'MM/dd/yyyy' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">Due Date</span>
                  <span class="value">
                    {{ project.dueDate | date: 'MM/dd/yyyy' }}
                  </span>
                </div>
              </mat-card-content>
            </mat-card>
          }
        </div>
      </div>
    </div>
  }

  @if (userAccount && !isMobile) {
    <div class="gcontainer bwhite">
      @if (!hasNoOfficeLocations) {
        <div class="row">
          <div class="col-md-4">
            <div class="dashboard-title">
              <img src="assets/images/dashboard-icon.jpg" alt="Dashboard" class="dashboard-icon" />
              <h1 class="mat-h1">Dashboard</h1>
            </div>
            <form (submit)="pageNavigate('keyWordSearch')" class="search-section">
              <mat-form-field appearance="outline" class="select-box">
                <mat-select [(ngModel)]="searchColumn" [ngModelOptions]="{ standalone: true }"
                  (selectionChange)="onSearchColumnChange($event.value)">
                  <mat-option value="all">ALL</mat-option>
                  <mat-option value="inHouseID">In-House ID</mat-option>
                  <mat-option value="customer">Customer</mat-option>
                  <mat-option value="projectName">Project Name</mat-option>
                  <mat-option value="projectNumber">Project Number</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="search-box">
                <input
                  matInput
                  placeholder="Search"
                  class="search-text"
                  maxlength="150"
                  (input)="onSearchChange()"
                  (keypress)="onKeyPress($event)"
                  (keydown)="onKeyDown($event)"
                  [(ngModel)]="searchKeyWord"
                  [ngModelOptions]="{ standalone: true }"
                  />
                  @if (roleCheck(['Admin'])) {
                    <mat-icon class="cursor askgeo" matSuffix (click)="askGeo()">
                      psychology
                    </mat-icon>
                  }
                  @if (searchKeyWord.length === 0) {
                    <mat-icon class="cursor search" matSuffix>
                      search
                    </mat-icon>
                  }
                  @if (searchKeyWord.length > 0) {
                    <mat-icon class="cursor search" matSuffix (click)="onClearSearchButtonClick()">
                      close
                    </mat-icon>
                  }
                </mat-form-field>
              </form>
            </div>
            <div class="col-md-8">
              <div class="row">
                @if (!roleCheck(['Manager', 'Admin'])) {
                  <div class="col-md-2 pt-16"></div>
                }
                <div class="col-md-2 pt-16 pl-16">
                  <mat-card class="shadow-none">
                    <mat-card-content>
                      <div class="soil-type">
                        <span class="mat-subtitle-2 bold-title">Turnrnd Time</span>
                      </div>
                      <div id="project-count-container" class="row">
                        <div class="col-md-6">
                          <h1 class="card-count mb-0 text-center">{{ defaultTurnaroundTime }}</h1>
                          <div class="font-12 text-center">Default</div>
                        </div>
                        <div class="col-md-6">
                          <h1 class="card-count mb-0 text-center">{{ rushTurnaroundTime }}</h1>
                          <div class="font-12 text-center">Rush</div>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>
                <div class="col-md-4 pt-16 pl-16">
                  <mat-card class="shadow-none">
                    <mat-card-content>
                      <div class="soil-type">
                        <span class="mat-subtitle-2 bold-title">Native Soil</span>
                      </div>
                      <app-project-count [projectCount]="projectsCount.nativeSoil"></app-project-count>
                    </mat-card-content>
                  </mat-card>
                </div>
                <div class="col-md-4 pt-16 pl-16">
                  <mat-card class="shadow-none">
                    <mat-card-content>
                      <div class="soil-type">
                        <span class="mat-subtitle-2 bold-title">Pre Cast</span>
                      </div>
                      <app-project-count [projectCount]="projectsCount.preCast"></app-project-count>
                    </mat-card-content>
                  </mat-card>
                </div>
                @if (roleCheck(['Manager', 'Admin'])) {
                  <div class="col-md-2 pt-16 pl-16">
                    <mat-card class="align-add-project shadow-none">
                      <mat-card-content>
                        <a (click)="routingPage()" href="javascript:void(0);">
                          <img class="new-project-icon" src="/assets/icons/plus-icon.svg" alt="add-project-icon" />
                        </a>
                      </mat-card-content>
                    </mat-card>
                  </div>
                }
              </div>
            </div>
          </div>
          <!-- Tab Starts -->
          <div class="tab-container mar-tp">
            @if (projectRecords.length > 0) {
              <div class="row">
                <div class="col-md-5">
                  @if (showSearchResultCount) {
                    <span class="search-results-count">
                      {{ totalRecords }} result(s) for "{{ searchKeyWord }}"
                    </span>
                  }
                </div>
              </div>
            }
            <div class="row">
              <div class="col-md-3 d-flex justify-content-left gap-3">
                <mat-checkbox [checked]="mixIdCheckboxValue" [(ngModel)]="mixIdCheckboxValue" color="primary"
                  (click)="$event.stopPropagation()" (change)="isSearchInMixId($event)" [disabled]="isMixIdCheckboxDisabled">
                  Include Mix ID
                </mat-checkbox>
                @if (roleCheck(['Admin','Manager', 'Reportwriter', 'Accounting'])) {
                  <mat-checkbox [checked]="inActiveRecordsCheckboxValue" [(ngModel)]="inActiveRecordsCheckboxValue"
                    color="primary"
                    (click)="$event.stopPropagation()" (change)="includeInactiveRecords($event)" [disabled]="isCheckboxDisabled">
                    Include Inactive records
                  </mat-checkbox>
                }
              </div>
              <div class="col-md-3">
              </div>
              <div class="col-md-3">
              </div>
              <div class="col-md-3 d-flex justify-content-end align-items-center gap-2">
                <div class="container-for-clearFilter">
                  @if (isAnyFilterApplied()) {
                    <a href="javascript:void(0);" (click)="clearFilters()" class="clear-filter">Clear Filter(s)</a>
                  }
                </div>
                @if (roleCheck(['Admin','Reportwriter','Manager'])) {
                  <div>
                    <button mat-raised-button color="primary" (click)="combine()">Combine</button>
                  </div>
                }
              </div>
            </div>
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" #matgroup animationDuration="0ms"
              [selectedIndex]="roleCheck(['Labtech']) ? 1 : selectedTab" (selectedIndexChange)="roleCheck(['Labtech']) ? 1 : selectedTab = $event" (selectedTabChange)="onTabChanged($event)">
              <mat-tab label="ALL PROJECTS">
                <ng-container *ngTemplateOutlet="dashboardTableContent"></ng-container>
              </mat-tab>
              @if (!roleCheck(['Accounting'])) {
<mat-tab [label]="
              roleCheck(['Labtech', 'Manager', 'Reportwriter']) ? 'MY PROJECTS' : 'REPORTS TO REVIEW'
            ">
                  <ng-container *ngTemplateOutlet="dashboardTableContent"></ng-container>
                </mat-tab>
              }
              @if (roleCheck(['Admin'])) {
                <mat-tab label="SHIPPING LOG">
                  <ng-container *ngTemplateOutlet="shippingLogTableContent"></ng-container>
                </mat-tab>
              }
              @if (roleCheck(['Admin'])) {
                <mat-tab [label]="'ROUTE THERMAL SURVEY'">
                  <ng-container *ngTemplateOutlet="fieldTestingTableContent"></ng-container>
                </mat-tab>
              }
              @if (roleCheck(['Admin'])) {
                <mat-tab [label]="'QUOTES'">
                  <ng-container *ngTemplateOutlet="quotesTableContent"></ng-container>
                </mat-tab>
              }
            </mat-tab-group>
          </div>
        } @else {
          <div class="no-office-location-error mar-tp">
            No office location is assigned to your account. Please contact your administrator to get access to projects.
          </div>
        }
      </div>
    }
    <ng-template #dashboardTableContent>
      <section class="dash-container">
        <mat-divider class="pb-24"></mat-divider>
        @if (
          projectRecords.length > 0 ||
          materialType ||
          projectStatus ||
          searchKeyWord ||
          selectedMaterialTypes ||
          selectedProjectStatus
          ) {
          <mat-table #table aria-describedby="Projects list" mat-table matSortDisableClear [dataSource]="dataSource" matSort
            (matSortChange)="sortData($event)" class="mat-table">
            <mat-header-row *matHeaderRowDef="displayedColumn.concat('action'); sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumn.concat('action')"
              [ngClass]="{'inactive-row': row.isActive === false, 'selected-row': selection.isSelected(row)}">
            </mat-row>
            @for (columnName of displayedColumn; track columnName) {
              <ng-container [matColumnDef]="columnName">
                <mat-header-cell class="header-text" *matHeaderCellDef mat-sort-header
                  [disabled]="columnName === 'soilType' || columnName === 'status' || columnName === 'assignedUser' || columnName === 'isSplit'"
                  [matTooltip]="getTooltipText(columnName)">
                  @if (columnName === 'select' && roleCheck(['Admin'])) {
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      (change)="masterToggle(); "
                      [checked]="isAllSelected()"
                      [indeterminate]="isIndeterminate()">
                    </mat-checkbox>
                  }
                  <!--Material Type column -->
                  @if (columnName === 'soilType') {
                    <ng-container class="material-width">
                      {{ getDisplayName(columnName) }}
                      <a href="javascript:void(0)" [matMenuTriggerFor]="materialType" #menuTrigger="matMenuTrigger"
                        class="cursor icon-float">
                      <img src="/assets/icons/Filter.svg" class="icon-mt-1" alt="alert-icon" /> </a><mat-menu
                      class="dashboard-menu mat-menu-box" #materialType="matMenu" yPosition="below" xPosition="before">
                      <mat-list (click)="$event.stopPropagation()">
                        @for (materialType of materialTypes; track materialType) {
                          <mat-list-item>
                            @if (!materialType.disabled) {
                              <mat-checkbox color="primary" [value]="materialType.id"
                    [checked]="selectedMaterialTypes.includes(materialType.label)" (change)="
                      onCheckboxClick(
                        $event.checked,
                        materialType.label,
                        selectedMaterialTypes,
                        materialTypes,
                        'materialType'
                      )
                    " (click)="$event.stopPropagation()">
                                {{ materialType.label }}
                              </mat-checkbox>
                            }
                          </mat-list-item>
                        }
                        <button mat-button class="btn-action btn-update"
                          (click)="pageNavigate('materialTypeCheck'); menuTrigger.closeMenu()">
                          UPDATE
                        </button>
                      </mat-list>
                    </mat-menu>
                  </ng-container>
                }
                <!--Status Column -->
                @if (columnName === 'status') {
                  {{ getDisplayName(columnName) }}
                  <a href="javascript:void(0)" [matMenuTriggerFor]="statusFilter" #menuTrigger="matMenuTrigger"
                    class="cursor icon-float">
                    @if (!((roleCheck(['Reportwriter','Admin', 'Labtech', 'Manager']) && this.myProjects))) {
                      <img src="/assets/icons/Filter.svg" class="icon-mt-1" alt="alert-icon"
                        />
                    } </a><mat-menu
                    class="dashboard-menu mat-menu-box" #statusFilter="matMenu" (click)="$event.stopPropagation()"
                    yPosition="below" xPosition="before" (click)="$event.stopPropagation()">
                    <mat-list (click)="$event.stopPropagation()">
                      @for (projectStatus of projectStatuses; track projectStatus) {
                        <mat-list-item>
                          <mat-checkbox color="primary" [value]="projectStatus.id"
                    [checked]="selectedProjectStatus.includes(projectStatus.label)" (change)="
                      onCheckboxClick(
                        $event.checked,
                        projectStatus.label,
                        selectedProjectStatus,
                        projectStatuses,
                        'projectStatus'
                      )
                    " (click)="$event.stopPropagation()">{{ projectStatus.label }}</mat-checkbox>
                        </mat-list-item>
                      }
                      <button #triggerBtn mat-button class="btn-action btn-update"
                        (click)="pageNavigate('projectStatusCheck'); menuTrigger.closeMenu()">
                        UPDATE
                      </button>
                    </mat-list>
                  </mat-menu>
                }
                <!-- Office Location Column -->
                @if (columnName === 'officeLocation') {
                  {{ getDisplayName(columnName) }}
                  <a href="javascript:void(0)" [matMenuTriggerFor]="officeLocationFilter" #officeMenuTrigger="matMenuTrigger"
                    class="cursor icon-float" (click)="$event.stopPropagation()">
                    @if (hasOfficeLocationChoice) {
                      <img src="/assets/icons/Filter.svg" class="icon-mt-1" alt="filter-icon" />
                    } </a><mat-menu
                    class="dashboard-menu mat-menu-box" #officeLocationFilter="matMenu" yPosition="below" xPosition="before">
                    <mat-list (click)="$event.stopPropagation()">
                      @for (office of officeLocations; track office) {
                        <mat-list-item>
                          <mat-checkbox color="primary" [value]="office.id"
                            [checked]="selectedOfficeLocations.includes(office.id)"
                            (change)="onOfficeLocationCheckboxClick($event.checked, office.id)"
                            (click)="$event.stopPropagation()">
                            {{ office.officeName }}@if (office.officeCode) {
                            ({{ office.officeCode }})
                          }
                        </mat-checkbox>
                      </mat-list-item>
                    }
                    <button mat-button class="btn-action btn-update"
                      (click)="applyOfficeLocationFilter(); officeMenuTrigger.closeMenu()">
                      UPDATE
                    </button>
                  </mat-list>
                </mat-menu>
              }
              @if (columnName !== 'soilType' && columnName !== 'status' && columnName !== 'officeLocation') {
                {{ getDisplayName(columnName) }}
              }
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="ellips">
              @if (columnName === 'select' && roleCheck(['Admin'])) {
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="toggleSelection(row);"
                  [checked]="selection.selected.includes(row)">
                </mat-checkbox>
              }
              <!-- Display  content for 'materialtype' column -->
              @if (columnName === 'soilType') {
                @if (row.soilType?.toLowerCase() === 'pre cast') {
                  <span
                    class="soil-type-icon cylinder-icon-wrapper"
                    [matTooltip]="row.soilType"
                    matTooltipPosition="above">
                    <mat-icon svgIcon="cylinder"></mat-icon>
                    <span class="icon-text">{{ row.inHouseIdPrefix }}</span>
                  </span>
                }
                @if (row.soilType?.toLowerCase() == 'native soil') {
                  <mat-icon
                    class="soil-type-icon terrain-icon"
                    [matTooltip]="row.soilType"
                    matTooltipPosition="above">
                    terrain
                  </mat-icon>
                }
                {{ showSampleCounts(row.sampleCountSummary) }}
              }
              <!-- Display  content for 'project reference' column -->
              @if (columnName === 'referenceId') {
                <span class="img-center">
                  {{ row.referenceId }}
                </span>
              }
              <!-- Display  content for 'status' column -->
              @if (columnName === 'status') {
                {{ row.status }}
              }
              <!-- Display  content for 'rush' column -->
              @if (columnName === 'rushed') {
                @if (row.rushed === true) {
                  <span class="img-center">
                    <img src="/assets/icons/Rush.svg" alt="alert-icon" />
                  </span>
                }
              }
              @if (columnName === 'isSplit') {
                @if (row.isSplit === true && row.isMerge === false) {
                  <span class="img-center">
                    <img src="/assets/icons/chain_link.svg" class="split" alt="split-icon" />
                  </span>
                }
              }
              @if (columnName === 'isSplit') {
                @if (row.isSplit === false && row.isMerge === true) {
                  <span class="img-center">
                    <img src="/assets/icons/Merge.svg" class="split" alt="merge-icon" />
                  </span>
                }
              }
              @if (columnName === 'isSplit') {
                @if (row.isCombine === true) {
                  <span class="img-center">
                    <img src="/assets/icons/combine.svg" class="split" alt="combine-icon" />
                  </span>
                }
              }
              @if (columnName === 'geothermField') {
                @if (row.geothermField === true) {
                  <span class="img-center geotherm-field">
                    <img src="/assets/icons/Success.svg" alt="success-icon" />
                  </span>
                }
              }
              @if (columnName === 'lastStatusChangedAt') {
                <span class="img-center" [matTooltip]="getRowDataByKey(row, columnName, true)">{{
                getRowDataByKey(row, columnName, false) }}</span>
              }
              <!-- Display default content for other columns -->
              @if (columnName !== 'soilType' && columnName !== 'status' && columnName !== 'rushed' && columnName !== 'geothermField' && columnName !== 'isSplit' && columnName !== 'lastStatusChangedAt' && columnName !== 'referenceId') {
                <span [matTooltip]="getRowDataByKey(row, columnName, true)"
                  >{{
                  getRowDataByKey(row, columnName, false) }}
                </span>
              }
            </mat-cell>
          </ng-container>
        }
        <!--action -->
        <ng-container matColumnDef="action" stickyEnd>
          <mat-header-cell class="header-text" *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button mat-icon-button [matMenuTriggerFor]="menu"
              [disabled]="roleCheck(['Labtech']) && row.isActive === false">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu class="dashboard-menu mat-menu-box" #menu="matMenu" xPosition="before" yPosition="below">
              @if (
                !isMultipleSelected(row) &&
                roleCheck(['Manager', 'Admin','Accounting']) ||
                (roleCheck(['Manager', 'Reportwriter']) && this.myProjects)
                ) {
                <button mat-menu-item class="btn-hover" (click)="review(row.id, row.soilType)">
                  <span class="menu-text">
                    <img src="/assets/icons/File.svg" alt="File-icon" />&nbsp; View Submission Form
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) && row.isActive === true && allUserAction()) {
                <button mat-menu-item (click)="openDialog(row, 'SetStatus')">
                  <span class="menu-text">
                    <img src="/assets/icons/Receipt.svg" alt="Done-icon" />&nbsp; Receive Shipment
                  </span>
                </button>
              }
              @if ( !isMultipleSelected(row) &&
                row.worksheetGenerated === true &&
                row.status !== 'Samples Due To Arrive' &&
                ((roleCheck(['Manager', 'Admin'])) || (roleCheck(['Reportwriter', 'Labtech']) && this.myProjects))) {
                <button mat-menu-item (click)="gotoWorksheet(row.id, row.worksheetGenerated, row.soilType)"
                  >
                  <span class="menu-text">
                    <img src="/assets/icons/List.svg" alt="List" />&nbsp;
                    {{ 'View Worksheet (OLD)'}}
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) &&
                row.soilType === 'Pre Cast' &&
                row.worksheetGenerated === true
                && row.status !== 'Samples Due To Arrive' &&
                ((roleCheck(['Manager', 'Admin'])) || (roleCheck(['Reportwriter', 'Labtech']) && this.myProjects))) {
                <button
                  mat-menu-item (click)="precastWorksheet(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/List.svg" alt="List" />&nbsp; Pre Cast Worksheet
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) &&
                row.worksheetGenerated === true &&
                row.soilType === 'Native Soil' &&
                row.status !== 'Samples Due To Arrive' &&
                ((roleCheck(['Manager', 'Admin'])) || (roleCheck(['Reportwriter', 'Labtech']) && this.myProjects))) {
                <button
                  mat-menu-item (click)="asReceivedWorksheet(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/List.svg" alt="List" />&nbsp; As Received Worksheet (NEW)
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) &&
                row.worksheetGenerated === true &&
                row.soilType === 'Native Soil' &&
                row.status !== 'Samples Due To Arrive' &&
                ((roleCheck(['Manager', 'Admin'])) || (roleCheck(['Reportwriter', 'Labtech']) && this.myProjects))) {
                <button
                  mat-menu-item (click)="moistureConditioningWorksheet(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/List.svg" alt="List" />&nbsp; Moisture Conditioning (NEW)
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) &&
                row.worksheetGenerated === true &&
                row.soilType === 'Native Soil' &&
                row.status !== 'Samples Due To Arrive' &&
                ((roleCheck(['Manager', 'Admin'])) || (roleCheck(['Reportwriter', 'Labtech']) && this.myProjects))) {
                <button
                  mat-menu-item (click)="singleProctorWorksheet(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/List.svg" alt="List" />&nbsp; Single Proctor (NEW)
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) &&
                row.worksheetGenerated === true &&
                row.soilType === 'Native Soil' &&
                row.status !== 'Samples Due To Arrive' &&
                ((roleCheck(['Manager', 'Admin'])) || (roleCheck(['Reportwriter', 'Labtech']) && this.myProjects))) {
                <button
                  mat-menu-item (click)="compactionWorksheet(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/List.svg" alt="List" />&nbsp; Compaction (NEW)
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) &&
                row.worksheetGenerated === true &&
                row.soilType === 'Native Soil' &&
                row.status !== 'Samples Due To Arrive' &&
                ((roleCheck(['Manager', 'Admin'])) || (roleCheck(['Reportwriter', 'Labtech']) && this.myProjects))) {
                <button
                  mat-menu-item (click)="nativeSoilWorksheet(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/List.svg" alt="List" />&nbsp; Native Soil Worksheet (NEW)
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row)) {
                <button mat-menu-item (click)="openAttachmentDrawer(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/Folder.svg" alt="File" />&nbsp; View Attachments
                  </span>
                </button>
              }
              @if (
                !isMultipleSelected(row) &&
                (roleCheck(['Manager', 'Admin','Accounting'])) ||
                (roleCheck(['Manager', 'Reportwriter']) && this.myProjects)
                ) {
                <button mat-menu-item (click)="openDialog(row, 'Notes')">
                  <span class="menu-text">
                    <img src="/assets/icons/Comment.svg" alt="Comment-icon" />&nbsp; View Notes
                  </span>
                </button>
              }
              @if (
                !isMultipleSelected(row) &&
                ((roleCheck(['Admin']) && shouldShowAdminManageReport(row)) ||
                (roleCheck(['Reportwriter']) && this.myProjects && shouldShowManageReport(row)) ||
                (roleCheck(['Manager']) && shouldShowManageReport(row)) ||
                (roleCheck(['Accounting']) && shouldShowAccountManageReport(row)))
                ) {
                <button mat-menu-item [routerLink]="['/report/edit', row?.soilType === 'Pre Cast' ? 'precast' : 'nativesoil', row.id]"
                  [disabled]="!row.dueDate"
                  [queryParams]="{ edit: 'true' }">
                  <span class="menu-text">
                    <img src="/assets/icons/Bar-chart.svg" alt="chart-icon" />&nbsp; Manage Report
                  </span>
                </button>
              }
              @if (
                !isMultipleSelected(row) &&
                row.status === 'Lab Manager Review' &&
                roleCheck(['Manager', 'Admin']) &&
                row.isActive === true
                ) {
                <button mat-menu-item (click)="assignToReportWriter(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/User-multiple.svg" alt="File" />&nbsp; Assign To Report Writer
                  </span>
                </button>
              }
              @if (
                !isMultipleSelected(row) &&
                !this.myProjects &&
                ((row.status === 'Lab Manager Review' && roleCheck(['Manager'])) ||
                (row.status === 'Ready To Report' && roleCheck(['Reportwriter']))) ||
                (displayAdminAssignToMyself(row) && row.isActive === true)) {
                <button mat-menu-item (click)="assignToMyself(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/User-multiple.svg" alt="File" />&nbsp; Assign To Myself
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) && (roleCheck(['Admin']) && shouldShowAddRate(row))) {
                <button mat-menu-item
                  (click)="addRates(row.id, row.soilType,row.status)">
                  <span class="menu-text">
                    <img src="/assets/icons/Add.svg" alt="bill-icon" />&nbsp; Add Rates
                  </span>
                </button>
              }
              @if (!isMultipleSelected(row) && (roleCheck(['Admin','Accounting']) && shouldShowBilling(row))) {
                <button mat-menu-item
                  (click)="manageBilling(row.id, row.soilType)">
                  <span class="menu-text">
                    <img src="/assets/icons/Bills.svg" alt="bill-icon" />&nbsp; Manage Billing
                  </span>
                </button>
              }
              @if (
                (!isMultipleSelected(row) && roleCheck(['Manager', 'Admin','Reportwriter']) && shouldShowMergeButton(row) && row.isActive === true)
                ) {
                <button mat-menu-item class="btn-hover" (click)="mergeProject(row.id, row.soilType)">
                  <span class="menu-text">
                    <img src="/assets/icons/Merge.svg" alt="File-icon" />&nbsp; Merge Project
                  </span>
                </button>
              }
              @if (
                !isMultipleSelected(row) &&
                (roleCheck(['Manager', 'Admin'])) ||
                (roleCheck(['Manager', 'Reportwriter']) && this.myProjects)
                ) {
                <button mat-menu-item (click)="projectAudit360(row.id, row.soilType, row.projectNumber, row.projectName, row.customer, row.status)">
                  <span class="menu-text">
                    <img src="/assets/icons/project-360-report.svg" alt="project-360-report-icon" />&nbsp; Project Audit 360
                  </span>
                </button>
              }
              @if (roleCheck(['Admin']) && row.isActive === true) {
                <button mat-menu-item
                  (click)="inactivateProjects(row.id, isMultipleSelected(row))">
                  <span class="menu-text">
                    <img src="/assets/icons/Remove.svg" alt="Inactive-icon" width="20px" />&nbsp; {{ isMultipleSelected(row) ? 'Deactivate Selected' : 'Deactivate' }}
                  </span>
                </button>
              }
              @if (roleCheck(['Admin'])) {
                <button mat-menu-item
                  (click)="deleteProject(row.id, row.soilType, isMultipleSelected(row))">
                  <span class="menu-text"> <img src="/assets/icons/Delete.svg" alt="Delete-icon" />&nbsp; {{ isMultipleSelected(row) ? 'Delete Selected' : 'Delete' }} </span>
                </button>
              }
              @if (!isMultipleSelected(row) && roleCheck(['Admin', 'Manager', 'Reportwriter']) && row.isActive === false) {
                <button mat-menu-item
                  (click)="restoreRecord(row.id)">
                  <span class="menu-text">
                    <img src="/assets/icons/Restore.svg" alt="Restore-icon" width="20px" />&nbsp; Restore
                  </span>
                </button>
              }
            </mat-menu>
          </mat-cell>
        </ng-container>
      </mat-table>
    }
  </section>
  @if (totalPages && projectRecords.length > 0) {
    <div class="dashboard-pagination">
      <mat-paginator [length]="totalRecords" #dashboarPaginator [pageIndex]="currentPage - 1"
        (page)="onPaginationNavigate($event)" [pageSize]="recordsPerPage" [pageSizeOptions]="[5, 10, 15, 50, 100]"
      showFirstLastButtons></mat-paginator>
    </div>
  }

  @if (
    (searchKeyWord && projectRecords.length === 0) ||
    (selectedProjectStatus && projectRecords.length === 0) ||
    (selectedMaterialTypes && projectRecords.length === 0)
    ) {
    <section class="no-search-section">
      <div class="search-result">No such records found</div>
    </section>
  }
</ng-template>

<ng-template #fieldTestingTableContent>
  <div class="under-development">under development...</div>
</ng-template>

<ng-template #quotesTableContent>
  <div class="under-development">under development...</div>
</ng-template>

<ng-template #shippingLogTableContent>
  <div class="under-development">under development...</div>
</ng-template>

<app-customer-attachments
  #attachmentsComponent
  [projectId]="attachmentProjectId"
  [backgroundClass]="'gray'"
  [showSuccess]="false"
  [showDrawerLink]="false"
  style="vertical-align: middle; margin-right: 16px">
</app-customer-attachments>